const InfoElem = ({
  children,
  heading,
  icon,
}: {
  children: React.ReactNode;
  heading: React.ReactNode;
  icon: React.ReactNode;
}) => {
  return (
    <div className="flex flex-col rounded-field bg-base-200 items-start justify-start gap-2 p-3 h-full">
      <div className="inline-flex w-full items-center ">
        <div className="px-1 ">{icon}</div>
        <div className="text-xl font-semibold overflow-x-scroll no-scrollbar">
          {heading}
        </div>
      </div>
      <div className="text-xl italic opacity-75">{children}</div>
    </div>
  );
};
export default InfoElem;
